const PageNotFound = () => (
  <div className="jw-flex jw-justify-center jw-mt-40">
    <p>Page not found</p>
  </div>
);

export default PageNotFound;
